import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import axios from "axios";
import { useSnackbar } from "notistack";
import {
    Container,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
    Grid,
    Box,
    CircularProgress,
    TablePagination,
    IconButton,
    Checkbox,
    FormControl,
    TextField,
    MenuItem,
    DialogContent
} from "@material-ui/core";
import { Replay, ArrowBack, Remove, Add } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import FileUpload from "./Upload";
import Benchmark from "./Benchmark";
import ValidationConfig from "./ValidationConfig";
import Rules from "./Rules";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useDispatch, useSelector } from 'react-redux';
import { savePage } from "../../actions/pageActions";
import ImageCard from "./assets/ImageCard";
import TestURL from "./assets/TestURL";
import DefaultModel from "./assets/DefaultModel";
import ConfModal from "./assets/ConfModal";
import PostProcessingModal from "./assets/PostProcessingModal";
import Header from "./assets/Header";
import { v4 as uuidv4 } from "uuid";
import { ocrTypes, navPath, navSearch } from "../../constants";
import { HV_THEME, HVHeader, HVButton, Card, Icons, StatusPill, HVInput } from "../shared/DesignSystem";

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(grey[900]),
        backgroundColor: grey[900],
        "&:hover": {
            backgroundColor: grey[900],
        },
        height: 50,
        minWidth: 100,
    },
}))(Button);

const useStyles = makeStyles({
    cards: {
        marginTop: 50,
        marginLeft: 25,
    }
});

function Project(props) {
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [projectLoading, setProjectLoading] = useState(true);

    const pageNumber = useSelector(
        (state) => state.page.pageNumber
    );
    const pageSize = useSelector(
        (state) => state.page.pageSize
    );

    const [recreate, setRecreate] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const [tagToDelete, setTagToDelete] = useState("");
    const [tags, setTags] = useState([]);
    const [openIsLocked, setOpenIsLocked] = useState(false);
    const [status, setStatus] = useState("");
    const [name, setName] = useState("");
    const [fieldsForHallucinationCheck, setFieldsForHallucinationCheck] = useState([]);
    const [percent, setPercent] = useState(0);
    const [openUpload, setOpenUpload] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);
    const [openPostProcessing, setOpenPostProcessing] = useState(false);
    const [openRules, setOpenRules] = useState(false);
    const [openBenchmark, setOpenBenchmark] = useState(false);
    const [openDeleteTag, setOpenDeleteTag] = useState(false);
    const [postProcessingURL, setPostProcessingURL] = useState("");
    const [confThreshold, setConfThreshold] = useState({});
    const [openConfThreshold, setOpenConfThreshold] = useState(false);
    const [modelGenerateDialog, setModelGenerateDialog] = useState(false);
    const [benchmark, setBenchmark] = useState({});
    const [validationConfig, setValidationConfig] = useState({});
    const [modelName, setModelName] = useState('');
    const [modelNameOpen, setModelNameOpen] = useState(false);
    const [uploadType, setUploadType] = useState('');
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [benchmarkLoading, setBenchmarkLoading] = useState(false);
    const [completedOcr, setCompletedOcr] = useState(0);
    const [completedAnnotations, setCompletedAnnotations] = useState(0);
    const [flags, setFlags] = useState({});
    const [flagged, setFlagged] = useState(false);
    const [openCurl, setOpenCurl] = useState(false);
    const [openClone, setOpenClone] = useState(false);
    const [ocr, setOCR] = useState("google");
    const [translate, setTranslate] = useState(false);
    const [sorting, setSorting] = useState(false);
    const [version, setVersion] = useState("3");
    const [modelVersion, setModelVersion] = useState("1");
    const [lexModel, setLexModel] = useState("openai:gpt-3.5-turbo");
    const [newLexModel, setNewLexModel] = useState("openai:gpt-3.5-turbo");
    const [lexMultiplier, setLexMultiplier] = useState(1);
    const [newLexMultiplier, setNewLexMultiplier] = useState(1);
    const [newName, setNewName] = useState("");
    const [showUpdateMessage, setShowUpdateMessage] = useState(false);
    const [prompt, setPrompt] = useState("");
    const classes = useStyles();
    const [projectType, setProjectType] = useState("");
    const [docType, setDocType] = useState("");
    const { enqueueSnackbar } = useSnackbar();

    const [newOCRType, setNewOCRType] = useState("");
    const [promptForClone, setPromptForClone] = useState("");
    const [promptSelect, setPromptSelect] = useState("prompt1");
    const [openLexNext, setOpenLexNext] = useState(false);
    const [inputFields, setInputFields] = useState([
        { id: uuidv4(), field: "", validationType: "", description: "", hallucinationCheck: true },
    ]);
    const [menuMode, setMenuMode] = useState("clone");
    const [openTagDialog, setOpenTagDialog] = useState(false);
    const [customTag, setCustomTag] = useState('');

    async function modelPercent() {
        try {
            const response = await axios.post("/api/projects/progressCheck", {
                email: props.auth.user.email,
                projectId: projectId,
            });
            setPercent(response.data);
            if (response.data === 100) window.location.reload();
            if (response.data < 0) {
                enqueueSnackbar('Model generation failed. You can retrain the project.', { variant: 'error' });
                window.location.reload();
            }
        } catch (err) {
            console.log(err);
        }
    }

    async function getStatus() {
        try {
            const response = await axios.post("/api/projects/status", {
                projectId: projectId,
            });
            const fieldsForHallucinationCheck = response.data.fieldConfigs.filter((item) => item.hallucinationCheck).map((item) => item.field);
            setInputFields(response.data.fieldConfigs.map((item) => {
                return {
                    id: uuidv4(),
                    field: item.field,
                    description: item.description,
                    hallucinationCheck: item.hallucinationCheck,
                }
            }));
            setStatus(response.data.status);
            setTags(response.data.tags);
            setName(response.data.name);
            setNewName(response.data.name + " clone");
            setModelName(response.data.default_model);
            setOCR(response.data.ocr);
            setNewOCRType(response.data.ocr);
            setTranslate(response.data.translate);
            setSorting(response.data.sorting);
            setModelVersion(response.data.version);
            setVersion(response.data.version);
            setPrompt(response.data.prompt);
            setPromptForClone(response.data.prompt);
            setLexModel(response.data.lexModel);
            setFieldsForHallucinationCheck(fieldsForHallucinationCheck);
            setLexMultiplier(response.data.lexMultiplier);
            setNewLexMultiplier(response.data.lexMultiplier);
            setIsLocked(response.data.isLocked);
            setProjectType(response.data.projectType);
            setDocType(response.data.type);
            const updatedAt = new Date(response.data?.updatedAt);
            const diffInMins = Math.floor(((new Date() - updatedAt) / 1000) / 60);
            if (diffInMins < 15) {
                setShowUpdateMessage(true);
            }
            if (response.data.postProcessingURL)
                setPostProcessingURL(response.data.postProcessingURL);
            if (response.data.confThreshold)
                setConfThreshold(response.data.confThreshold);
            else {
                const fields = response.data.fieldConfigs.map((item) => item.field);
                const confFields = fields.reduce((a, v) => ({ ...a, [v]: 0.75 }), {})
                setConfThreshold(confFields);
            }
        } catch (err) {
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        } finally {
            setProjectLoading(false);
        }
    }

    async function fetchConfig() {
        try {
            const response = await axios.post("/api/projects/fetchConfig", {
                projectId: projectId,
            });
            setValidationConfig(response.data);
        } catch (err) {
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        }
    }

    const handleLock = async () => {
        try {
            setOpenIsLocked(false);
            const response = await axios.post("/api/projects/lock", {
                projectId: projectId,
            });
            if (response) {
                enqueueSnackbar(response.data, {
                    variant: "success",
                });
            }
            getStatus()
        } catch (error) {
            enqueueSnackbar(error.response.data, {
                variant: "error",
            });
        }
    };

    const handleTranslate = async () => {
        try {
            const response = await axios.post('/api/projects/translation', {
                projectId: projectId,
                value: !translate,
            });
            if (response) {
                setTranslate(!translate);
                console.log(response);
                enqueueSnackbar(response.data, {
                    variant: "success",
                });
            }
        } catch (err) {
            console.log('Translate error', err);
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        }
    }

    const deleteTagSetter = (tag) => {
        setTagToDelete(tag);
        setOpenDeleteTag(true);
    }

    const handleAddTag = (tag) => {
        if (!tag || !tag.trim()) return;
        axios.post('/api/projects/addTagToProjects', { projectIds: [projectId], tag: tag.trim() })
            .then(res => {
                enqueueSnackbar(res.data || 'Tag added', { variant: 'success' });
                setCustomTag('');
                setOpenTagDialog(false);
                getStatus();
            })
            .catch(err => enqueueSnackbar(err?.response?.data || 'Error adding tag', { variant: 'error' }));
    };

    const handleSorting = async () => {
        try {
            const response = await axios.post('/api/projects/sorting', {
                projectId: projectId,
                value: !sorting,
            });
            if (response) {
                setSorting(!sorting);
                console.log(response);
                enqueueSnackbar(response.data, {
                    variant: "success",
                });
            }
        } catch (err) {
            console.log('Sorting error', err);
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        }
    }

    const handleModel = async () => {
        try {
            closeModelGenerateDialog(false);
            const response = await axios.post("/api/projects/generate", {
                projectId: projectId,
                recreate,
            });
            if (response) {
                enqueueSnackbar("Running Model", {
                    variant: "success",
                });
            }
        } catch (error) {
            enqueueSnackbar(error.response.data, {
                variant: "error",
            });
        }
    };

    const handleClone = async () => {
        try {
            handleCloneClose();
            const response = await axios.post("/api/projects/clone", {
                projectId: projectId,
                version,
                name: newName,
                inputFields,
                promptForClone,
                ocr: newOCRType,
                lexModel: newLexModel,
                lexMultiplier: newLexMultiplier,
            });
            if (response) {
                enqueueSnackbar("Project cloned", {
                    variant: "success",
                });
            }
        } catch (error) {
            enqueueSnackbar(error.response.data, {
                variant: "error",
            });
        }
    };

    const handleUpdate = async () => {
        try {
            handleCloneClose();
            const response = await axios.post("/api/projects/updateProject", {
                projectId: projectId,
                inputFields,
                promptForClone,
                ocr: newOCRType,
                lexModel: newLexModel,
                lexMultiplier: newLexMultiplier,
            });
            if (response) {
                enqueueSnackbar("Project updated", {
                    variant: "success",
                });
                getStatus();
            }
        } catch (error) {
            enqueueSnackbar(error.response.data, {
                variant: "error",
            });
        }
    };

    const updatePromptValue = (fieldValues, promptStyle = promptSelect) => {
        let result;
        if (promptStyle === "prompt1") {
            result = fieldValues.map(({ field, description }) => `${field} (${description})`).join(', ');
        } else if (promptStyle === "prompt2") {
            result = fieldValues.map(({ field }) => `${field}`).join(', ');
        }
        if (result) {
            setPromptForClone(`Extract information as a JSON:\nExtract: ${result}\n\${ocr}`);
        }
    }

    const handleChangeLexInput = (id, event) => {
        const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
                i[event.target.name] = event.target.value;
            }
            return i;
        });
        setInputFields(newInputFields);
        updatePromptValue(newInputFields);
    };

    const handlePromptSelect = (e) => {
        setPromptSelect(e.target.value);
        updatePromptValue(inputFields, e.target.value);
    };

    const handleHallucinationCheck = (id, e) => {
        const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
                i[e.target.name] = e.target.checked;
            }
            return i;
        });
        setInputFields(newInputFields);
    }

    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setInputFields(values);
        updatePromptValue(values);
    };

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            { id: uuidv4(), field: "", validationType: "", description: "", hallucinationCheck: true },
        ]);
    };

    const handleChangeLexPrompt = (event) => {
        setPromptForClone(event.target.value);
    };

    const handleBack = () => {
        setOpenClone(true);
        setOpenLexNext(false);
    };

    const handleOpenNext = () => {
        setOpenLexNext(true);
        setOpenClone(false);
    };

    const handleOcrType = (e) => {
        setNewOCRType(e.target.value);
    };

    const handleBenchmark = async () => {
        try {
            setBenchmarkLoading(true);
            const response = await axios.post("/api/projects/getBenchmarks", {
                projectId: projectId,
            });
            setBenchmark(response.data);
            setOpenBenchmark(true);
        } catch (err) {
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        }
        setBenchmarkLoading(false);
    };

    const getImages = async () => {
        try {
            setLoading(true);
            const response = await axios.post('api/projects/images/list', {
                projectId: projectId,
            });
            response.data.images.sort((a, b) => (Number(a.key.split('/').pop().split('.')[0]) > Number(b.key.split('/').pop().split('.')[0]) ? 1 : -1));
            setImages(response.data.images);
        } catch (err) {
            enqueueSnackbar(err.response.data, {
                variant: "error",
            });
        }
        setLoading(false);
    }

    const getFlags = async () => {
        try {
            const flagsResponse = await axios.post('/api/projects/flags/view', {
                projectId: projectId,
            });
            setFlags(flagsResponse.data);
        } catch (err) {
            console.log('Get flags error', err);
        }
    }

    const refreshData = async () => {
        getStatus();
        getImages();
    }

    const fromGroupId = props.location?.state?.fromGroupId;
    const fromGroupName = props.location?.state?.fromGroupName;

    const handleGoBack = () => {
        if (fromGroupId) {
            props.history.push(navPath(`/group/${fromGroupId}`));
        } else {
            props.history.push({ pathname: '/' });
        }
    };

    const handleClickOpen = (type) => {
        setUploadType(type);
        setOpenUpload(true);
    };

    const handlCloseIsLocked = () => {
        setOpenIsLocked(false);
    };

    const handlOpenIsLocked = () => {
        setOpenIsLocked(true);
    };

    const handleClose = () => {
        setOpenUpload(false);
    };

    const handlePostProcessingOpen = () => {
        setOpenPostProcessing(true);
    };

    const handlePostProcessingClose = () => {
        setOpenPostProcessing(false);
    };

    const handleConfThresholdOpen = () => {
        setOpenConfThreshold(true);
    };

    const handleConfThresholdClose = () => {
        setOpenConfThreshold(false);
    };

    const handleConfigOpen = () => {
        setOpenConfig(true);
    };

    const handleCloseConfig = () => {
        setOpenConfig(false);
    };

    const handleOpenRules = () => {
        setOpenRules(true);
    };

    const handleCloseRules = () => {
        setOpenRules(false);
    };

    const handleCloseBenchmark = () => {
        setOpenBenchmark(false);
    };

    const openModelGenerateDialog = () => {
        setModelGenerateDialog(true);
    };

    const closeModelGenerateDialog = () => {
        setModelGenerateDialog(false);
    };

    const handlePostProcessingURL = (event) => {
        setPostProcessingURL(event.target.value);
    };

    const handleConfThreshold = (event) => {
        setConfThreshold({ ...confThreshold, [event.target.name]: parseFloat(event.target.value) });
    };

    const handleModelName = (event) => {
        setModelName(event.target.value);
    }

    const handleModelNameOpen = () => {
        setModelNameOpen(true);
    }

    const handleModelNameClose = () => {
        setModelNameOpen(false);
    }

    const handleCurlOpen = () => {
        setOpenCurl(true);
    }

    const handleCurlClose = () => {
        setOpenCurl(false);
    }

    const handleRecreate = (e) => {
        setRecreate(e.target.checked);
    };

    const handleCloneOpen = () => {
        setMenuMode("clone");
        setOpenClone(true);
    }

    const handleUpdateOpen = () => {
        setMenuMode("update");
        setOpenClone(true);
    }

    const handleCloneClose = () => {
        setOpenClone(false);
        setOpenLexNext(false);
    }

    const handleVersion = (e) => {
        setVersion(e.target.value)
    }

    const handleNewLexModel = (e) => {
        setNewLexModel(e.target.value)
    }

    const handleNewLexMultiplier = (e) => {
        setNewLexMultiplier(e.target.value)
    }

    const handleName = (e) => {
        setNewName(e.target.value);
    };

    useEffect(() => {
        let intervalId;
        if (status === "model_generating") {
            intervalId = setInterval(modelPercent, 10000);
        }
        return () => {
            clearInterval(intervalId);
        };
    }, [status]);

    useEffect(() => {
        if (projectId) {
            getStatus();
            fetchConfig();
            getImages();
            getFlags();
        }
    }, [projectId]);

    useEffect(() => {
        let ocrCount = 0;
        let annotationCount = 0;
        images.forEach(image => {
            if (image.ocr) {
                ocrCount++;
            }
            if (image.annotation) {
                annotationCount++;
            }
        });
        setCompletedOcr(ocrCount);
        setCompletedAnnotations(annotationCount);
    }, [completedAnnotations, completedOcr, images]);

    //***   LOGIC FOR PAGINATION  ** */
    const handleAnnotate = (id) => {
        props.history.push(navPath(`/annotate/${projectId}/${id}`));
    };

    const handleViewAnnotation = (id) => {
        props.history.push(navPath(`/viewAnnotation/${projectId}/${id}`));
    }

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState('overview');
    useEffect(() => {
        setPage(pageNumber);
        setRowsPerPage(pageSize);
    }, [])
    const offset = page * rowsPerPage;
    const currentPageData = images
        .slice(offset, offset + rowsPerPage)
        .map((image, index) => {
            const imageId = image.key.split('/')[2].split('.')[0];
            const card = <ImageCard
                image={image}
                index={index}
                handleViewAnnotation={handleViewAnnotation}
                handleAnnotate={handleAnnotate}
                getImages={getImages}
                flags={flags}
                projectId={projectId}
            />
            if (flagged) {
                if (flags[imageId] === true)
                    return card;
                return '';
            }
            return card;
        })

    const handleChangePage = (event, newPage) => {
        dispatch(savePage(newPage, rowsPerPage));
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        dispatch(savePage(page, event.target.value));
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    //***************************** */

    const handleTest = () => {
        props.history.push({
            pathname: "/test",
            search: navSearch(),
            state: { project: projectId, projectType: projectType }
        });
    };

    if (projectLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }

    const TABS = [
        { id: 'overview', label: 'Overview' },
        { id: 'data', label: 'Data & Images' },
    ];

    const flaggedCount = Object.values(flags).filter(Boolean).length;
    const TAG_PALETTE = {
        'Production': { bg: '#e7f5ed', fg: '#0f5d2a', bd: '#b7dfca' },
        'Testing':    { bg: '#e6efff', fg: '#1a3a8a', bd: '#b3c9f7' },
        'In Review':  { bg: '#fdf1dc', fg: '#7a4a07', bd: '#f5d68a' },
    };

    return (
        <div style={{ background: HV_THEME.bg, minHeight: '100vh', paddingBottom: 60, fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", color: HV_THEME.ink }}>
            <HVHeader tab="projects" showTabs={false} role={{ name: 'Admin', initials: 'AD', color: '#e6194b', label: 'Admin' }} env="STAGING" onLogout={() => props.history.push('/login')} />

            {/* Breadcrumb bar */}
            <div style={{ background: '#fff', borderBottom: '1px solid #ececec', padding: '14px 40px' }}>
                <div style={{ maxWidth: 1440, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <HVButton variant="ghost" size="sm" icon={<Icons.arrowL size={14} />} onClick={handleGoBack}>Back</HVButton>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: HV_THEME.mute }}>
                            {fromGroupId ? (
                                <>
                                    <span style={{ cursor: 'pointer' }} onClick={() => props.history.push(navPath('/'))}>Groups</span>
                                    <span>/</span>
                                    <span style={{ cursor: 'pointer' }} onClick={handleGoBack}>{fromGroupName || fromGroupId}</span>
                                </>
                            ) : (
                                <span style={{ cursor: 'pointer' }} onClick={handleGoBack}>Projects</span>
                            )}
                            <span>/</span>
                            <span style={{ color: HV_THEME.ink, fontWeight: 600 }}>{name || projectId}</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <StatusPill tone={isLocked ? 'warn' : 'ok'} size="sm">{isLocked ? 'Locked' : 'Active'}</StatusPill>
                        <HVButton variant="ghost" size="sm" icon={<Icons.refresh size={13} />} onClick={refreshData}>Refresh</HVButton>
                        <HVButton variant="ghost" size="sm" icon={<Icons.lock size={13} />} onClick={handlOpenIsLocked}>{isLocked ? 'Unlock' : 'Lock'}</HVButton>
                    </div>
                </div>
            </div>

            <div style={{ padding: '24px 40px', maxWidth: 1440, margin: '0 auto' }}>
                {/* Tab bar */}
                <div style={{ display: 'flex', borderBottom: '1px solid #ececec', marginBottom: 24, gap: 4 }}>
                    {TABS.map(t => (
                        <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
                            background: 'transparent', border: 0, padding: '10px 16px',
                            fontSize: 13, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer',
                            color: activeTab === t.id ? '#000' : '#888',
                            borderBottom: activeTab === t.id ? '2px solid #000' : '2px solid transparent',
                            marginBottom: -1, letterSpacing: '0.02em', display: 'inline-flex', alignItems: 'center', gap: 6
                        }}>
                            {t.label}
                            {t.badge && <span style={{ background: '#000', color: '#fff', fontSize: 9, padding: '2px 6px', borderRadius: 99, letterSpacing: '0.08em', fontWeight: 700 }}>{t.badge}</span>}
                        </button>
                    ))}
                </div>

                {/* ── OVERVIEW ── */}
                {activeTab === 'overview' && (
                    <>
                        {showUpdateMessage && <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 4, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#7a4a00' }}>⚡ Changes may take up to 15 minutes to reflect.</div>}
                        {status === 'model_generating' && <div style={{ background: '#e3f2fd', border: '1px solid #90caf9', borderRadius: 4, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#0d47a1' }}>🔄 Generating model… {percent}%</div>}
                        {status === 'model_generation_failed' && <div style={{ background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: 4, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#b71c1c' }}>⚠️ Model generation failed. You can retrain using the button below.</div>}

                        {/* Model config card */}
                        <Card pad={0} style={{ marginBottom: 20 }}>
                            <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Model</div>
                                    <div style={{ fontSize: 18, fontWeight: 700, marginTop: 4 }}>{version === 'lex' ? 'Lex configuration' : `v${modelVersion} configuration`}</div>
                                </div>
                                {version === 'lex' && <HVButton variant="secondary" size="sm" icon={<Icons.cog size={12} />} onClick={handleUpdateOpen}>Edit</HVButton>}
                            </div>
                            <div style={{ padding: '16px 20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px 32px', marginBottom: prompt && version === 'lex' ? 16 : 0 }}>
                                    {[
                                        { label: 'OCR Engine', value: ocr?.toUpperCase() || 'GOOGLE' },
                                        { label: 'Version', value: modelVersion || '1' },
                                        version === 'lex' ? { label: 'Lex Model', value: lexModel, mono: true } : { label: 'Status', value: status?.replace(/_/g, ' ') },
                                        version === 'lex' ? { label: 'Multiplier', value: String(lexMultiplier) } : null,
                                        { label: 'Conf. Threshold', value: confThreshold && Object.keys(confThreshold).length ? String(Object.values(confThreshold)[0]) : '—' },
                                        { label: 'Post-processing', value: postProcessingURL || '—' },
                                    ].filter(Boolean).map(item => (
                                        <div key={item.label}>
                                            <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>{item.label}</div>
                                            <div style={{ fontSize: 13, fontWeight: 600, fontFamily: item.mono ? "'JetBrains Mono', monospace" : 'inherit' }}>{item.value}</div>
                                        </div>
                                    ))}
                                </div>
                                {version === 'lex' && prompt && (
                                    <details style={{ borderTop: '1px solid #f0f0f0', paddingTop: 12, marginTop: 4 }}>
                                        <summary style={{ cursor: 'pointer', fontSize: 12, color: HV_THEME.mute, display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Icons.spark size={14} /> Extraction prompt · ~{prompt.length} chars
                                        </summary>
                                        <pre style={{ fontSize: 11, background: '#f9f9f9', padding: 12, borderRadius: 4, marginTop: 10, whiteSpace: 'pre-wrap', color: '#333', fontFamily: "'JetBrains Mono', monospace" }}>{prompt}</pre>
                                    </details>
                                )}
                            </div>
                        </Card>

                        {/* Tags */}
                        <Card pad={0} style={{ marginBottom: 20 }}>
                            <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 80 }}>
                                    <Icons.tag size={13} stroke={HV_THEME.mute} />
                                    <span style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Tags</span>
                                </div>
                                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', flex: 1, alignItems: 'center' }}>
                                    {tags && tags.length > 0 ? tags.map(tag => {
                                        const tp = TAG_PALETTE[tag] || { bg: '#f1f1f1', fg: '#3a3a3a', bd: '#e0e0e0' };
                                        return (
                                            <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: tp.bg, border: `1px solid ${tp.bd}`, borderRadius: 99, padding: '4px 10px 4px 12px', fontSize: 11, fontWeight: 600, color: tp.fg }}>
                                                {tag}
                                                <button onClick={() => deleteTagSetter(tag)} title="Remove tag" style={{ background: 'transparent', border: 0, cursor: 'pointer', color: tp.fg, opacity: 0.6, padding: 0, display: 'inline-flex', alignItems: 'center', marginLeft: 2 }}>
                                                    <Icons.x size={10} />
                                                </button>
                                            </span>
                                        );
                                    }) : (
                                        <span style={{ fontSize: 12, color: HV_THEME.mute }}>No tags — add one to categorise this project</span>
                                    )}
                                </div>
                                <HVButton size="sm" variant="ghost" icon={<Icons.tag size={12} />} onClick={() => setOpenTagDialog(true)}>Add tag</HVButton>
                            </div>
                        </Card>

                        {/* Manage project actions */}
                        <div style={{ marginBottom: 28 }}>
                            <div style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 6 }}>Actions</div>
                            <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 16, letterSpacing: '-0.02em' }}>Manage this project</div>

                            {/* DATA */}
                            <Card pad={0} style={{ marginBottom: 10 }}>
                                <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 110 }}>
                                        <Icons.folder size={13} stroke={HV_THEME.mute} />
                                        <span style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Data</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.folder size={13} />} onClick={() => handleClickOpen('folder')}>Upload folder</HVButton>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.image size={13} />} onClick={() => handleClickOpen('files')}>Upload images</HVButton>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.zip size={13} />} onClick={() => handleClickOpen('zip')}>Upload ZIP</HVButton>
                                        <HVButton size="sm" variant={flagged ? 'accent' : 'ghost'} icon={<Icons.flag size={13} />} disabled={!images.length} onClick={() => setFlagged(!flagged)}>
                                            Flagged images{flaggedCount > 0 && <span style={{ marginLeft: 5, background: HV_THEME.accent, color: '#fff', borderRadius: 99, padding: '1px 6px', fontSize: 9, fontWeight: 700 }}>{flaggedCount}</span>}
                                        </HVButton>
                                        <HVButton size="sm" variant="ghost" icon={<Icons.x size={13} />} onClick={handleTranslate}>{translate ? 'Disable translation' : 'Enable translation'}</HVButton>
                                        <HVButton size="sm" variant="ghost" icon={<Icons.x size={13} />} onClick={handleSorting}>{sorting ? 'Disable sorting' : 'Enable sorting'}</HVButton>
                                    </div>
                                </div>
                            </Card>

                            {/* MODEL */}
                            {projectType !== 'validation' && (
                                <Card pad={0} style={{ marginBottom: 10 }}>
                                    <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 110 }}>
                                            <Icons.brain size={13} stroke={HV_THEME.mute} />
                                            <span style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Model</span>
                                        </div>
                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                            <HVButton size="sm" variant="primary" icon={<Icons.refresh size={13} />} disabled={status === 'model_generating'} onClick={openModelGenerateDialog}>
                                                {status !== 'model_generated' ? 'Generate model' : 'Retrain model'}
                                            </HVButton>
                                            <HVButton size="sm" variant="secondary" icon={<Icons.check size={13} />} disabled={status !== 'model_generated'} onClick={handleModelNameOpen}>Set default model</HVButton>
                                            <HVButton size="sm" variant="secondary" icon={<Icons.cog size={13} />} disabled={status !== 'model_generated'} onClick={handleConfThresholdOpen}>Set conf. threshold</HVButton>
                                            <HVButton size="sm" variant="secondary" icon={<Icons.cog size={13} />} disabled={status !== 'model_generated'} onClick={handleOpenRules}>Set/edit rules</HVButton>
                                        </div>
                                    </div>
                                </Card>
                            )}

                            {/* CONFIGURATION */}
                            <Card pad={0} style={{ marginBottom: 10 }}>
                                <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 110 }}>
                                        <Icons.cog size={13} stroke={HV_THEME.mute} />
                                        <span style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Configuration</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.external size={13} />} onClick={handlePostProcessingOpen}>
                                            {postProcessingURL ? 'Update post-processing URL' : 'Set post-processing URL'}
                                        </HVButton>
                                        {projectType && projectType !== 'extraction' && (
                                            <HVButton size="sm" variant="secondary" icon={<Icons.cog size={13} />} onClick={handleConfigOpen}>Edit validation config</HVButton>
                                        )}
                                        {version === 'lex' && (
                                            <HVButton size="sm" variant="secondary" icon={<Icons.cog size={13} />} onClick={handleUpdateOpen}>Update project config</HVButton>
                                        )}
                                    </div>
                                </div>
                            </Card>

                            {/* TESTING */}
                            <Card pad={0}>
                                <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 110 }}>
                                        <Icons.beaker size={13} stroke={HV_THEME.mute} />
                                        <span style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Testing</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                        <HVButton size="sm" variant="primary" icon={<Icons.beaker size={13} />} disabled={status !== 'model_generated' && projectType !== 'validation'} onClick={handleTest}>Test model</HVButton>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.external size={13} />} onClick={handleCurlOpen}>Testing URL</HVButton>
                                        <HVButton size="sm" variant="secondary" icon={<Icons.copy size={13} />} onClick={handleCloneOpen}>Clone</HVButton>
                                        {projectType !== 'validation' && (
                                            <HVButton size="sm" variant="secondary" icon={<Icons.check size={13} />} disabled={status !== 'model_generated'} onClick={handleBenchmark}>
                                                {benchmarkLoading ? 'Loading…' : 'Test set metrics'}
                                            </HVButton>
                                        )}
                                    </div>
                                </div>
                            </Card>
                        </div>

                        {/* Sample images */}
                        <div>
                            <div style={{ fontSize: 9, letterSpacing: '0.14em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 6 }}>Data</div>
                            <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', marginBottom: 4 }}>Sample images</div>
                            <div style={{ fontSize: 13, color: HV_THEME.mute, marginBottom: 14 }}>{images.length} images · {completedOcr} OCR'd · {completedAnnotations} annotated</div>
                            <div style={{ background: '#fff', border: '1px solid #ececec', borderRadius: 4 }}>
                                <div style={{ borderBottom: '1px solid #ececec', padding: '4px 8px' }}>
                                    <TablePagination component="div" count={images.length} page={page} onChangePage={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} rowsPerPageOptions={[10, 25, 50, 100, 150, 200, 250, 300, 400, 500]} />
                                </div>
                                <div style={{ padding: 16 }}>
                                    {loading ? <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><CircularProgress /></div>
                                    : images.length === 0 ? (
                                        <div style={{ textAlign: 'center', padding: '40px 20px', color: HV_THEME.mute }}>
                                            <Icons.image size={32} stroke={HV_THEME.mute} />
                                            <div style={{ marginTop: 12, fontSize: 14, fontWeight: 600, color: HV_THEME.ink }}>No images yet</div>
                                            <div style={{ fontSize: 13, marginTop: 4 }}>Upload images above to get started.</div>
                                        </div>
                                    ) : <Grid container spacing={2}>{currentPageData}</Grid>}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* DATA tab */}
                {activeTab === 'data' && (
                    <>
                        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
                            <HVButton size="sm" variant="secondary" icon={<Icons.folder size={13} />} onClick={() => handleClickOpen('folder')}>Upload folder</HVButton>
                            <HVButton size="sm" variant="secondary" icon={<Icons.image size={13} />} onClick={() => handleClickOpen('files')}>Upload images</HVButton>
                            <HVButton size="sm" variant="secondary" icon={<Icons.zip size={13} />} onClick={() => handleClickOpen('zip')}>Upload ZIP</HVButton>
                            <HVButton size="sm" variant={flagged ? 'accent' : 'ghost'} icon={<Icons.flag size={13} />} disabled={!images.length} onClick={() => setFlagged(!flagged)}>{flagged ? 'All images' : 'Flagged images'}</HVButton>
                            <HVButton size="sm" variant="ghost" icon={<Icons.x size={13} />} onClick={handleTranslate}>{translate ? 'Disable translation' : 'Enable translation'}</HVButton>
                            <HVButton size="sm" variant="ghost" icon={<Icons.x size={13} />} onClick={handleSorting}>{sorting ? 'Disable sorting' : 'Enable sorting'}</HVButton>
                        </div>
                        <div style={{ background: '#fff', border: '1px solid #ececec', borderRadius: 4 }}>
                            <div style={{ borderBottom: '1px solid #ececec', padding: '4px 8px' }}>
                                <TablePagination component="div" count={images.length} page={page} onChangePage={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} rowsPerPageOptions={[10, 25, 50, 100, 150, 200, 250, 300, 400, 500]} />
                            </div>
                            <div style={{ padding: 16 }}>
                                {loading ? <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><CircularProgress /></div>
                                : images.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: HV_THEME.mute }}>No images yet</div>
                                : <Grid container spacing={2}>{currentPageData}</Grid>}
                            </div>
                        </div>
                    </>
                )}

                {activeTab === 'audit' && <div style={{ padding: 40, textAlign: 'center', color: HV_THEME.mute }}>Audit log not available</div>}
                {activeTab === 'future' && <div style={{ padding: 40, textAlign: 'center', color: HV_THEME.mute }}>Future plans coming soon…</div>}
            </div>
            <Dialog open={openIsLocked} onClose={handlCloseIsLocked} aria-labelledby="togglelock-project" maxWidth='sm' fullWidth>
                <DialogTitle id="togglelock-project" style={{ position: 'relative', paddingRight: 48 }}>
                    {isLocked ? 'Unlock' : 'Lock'} this project?
                    <IconButton onClick={handlCloseIsLocked} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div style={{ fontSize: 13, color: HV_THEME.mute }}>
                        {isLocked ? 'Unlocking will allow edits and model generation.' : 'Locking will prevent edits until unlocked.'}
                    </div>
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handlCloseIsLocked}>Cancel</HVButton>
                    <HVButton variant="primary" onClick={handleLock}>{isLocked ? 'Unlock' : 'Lock'}</HVButton>
                </DialogActions>
            </Dialog>
            <Dialog open={openUpload} onClose={handleClose} aria-labelledby="upload" PaperProps={{ style: { position: 'relative' } }}>
                <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8, zIndex: 10, background: 'rgba(255,255,255,0.9)' }}>
                    <Icons.x size={18} />
                </IconButton>
                <FileUpload projectId={projectId} type={uploadType} uploadData='project' setOpenUpload={setOpenUpload} getImages={getImages} />
            </Dialog>
            <Dialog open={openBenchmark} onClose={handleCloseBenchmark} aria-labelledby="benchmark" fullWidth maxWidth="lg" PaperProps={{ style: { position: 'relative' } }}>
                <IconButton onClick={handleCloseBenchmark} style={{ position: 'absolute', right: 8, top: 8, zIndex: 10, background: 'rgba(255,255,255,0.9)' }}>
                    <Icons.x size={18} />
                </IconButton>
                <Benchmark benchmark={benchmark} />
            </Dialog>
            <Dialog open={openRules} onClose={handleCloseRules} aria-labelledby="rules" fullWidth maxWidth="lg" PaperProps={{ style: { position: 'relative' } }}>
                <IconButton onClick={handleCloseRules} style={{ position: 'absolute', right: 8, top: 8, zIndex: 10, background: 'rgba(255,255,255,0.9)' }}>
                    <Icons.x size={18} />
                </IconButton>
                <Rules project={projectId} setOpenRules={setOpenRules} />
            </Dialog>
            <Dialog open={openConfig} onClose={handleCloseConfig} aria-labelledby="config" fullWidth maxWidth="lg" PaperProps={{ style: { position: 'relative' } }}>
                <IconButton onClick={handleCloseConfig} style={{ position: 'absolute', right: 8, top: 8, zIndex: 10, background: 'rgba(255,255,255,0.9)' }}>
                    <Icons.x size={18} />
                </IconButton>
                <ValidationConfig config={validationConfig} project={projectId} />
            </Dialog>
            <PostProcessingModal
                openPostProcessing={openPostProcessing}
                setOpenPostProcessing={setOpenPostProcessing}
                handlePostProcessingClose={handlePostProcessingClose}
                postProcessingURL={postProcessingURL}
                handlePostProcessingURL={handlePostProcessingURL}
                project={projectId}
            />
            <ConfModal
                openConfThreshold={openConfThreshold}
                setOpenConfThreshold={setOpenConfThreshold}
                handleConfThresholdClose={handleConfThresholdClose}
                confThreshold={confThreshold}
                handleConfThreshold={handleConfThreshold}
                project={projectId}
            />
            <Dialog open={modelGenerateDialog} onClose={closeModelGenerateDialog} aria-labelledby="generate-model" maxWidth="xs" fullWidth>
                <DialogTitle id="generate-model" style={{ position: 'relative', paddingRight: 48 }}>
                    Start model generation?
                    <IconButton onClick={closeModelGenerateDialog} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Checkbox checked={recreate} onChange={handleRecreate} inputProps={{ "aria-label": "primary checkbox" }} />
                        <span style={{ fontSize: 13 }}>Recreate completion files</span>
                    </div>
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={closeModelGenerateDialog}>Cancel</HVButton>
                    <HVButton variant="primary" onClick={handleModel}>Confirm</HVButton>
                </DialogActions>
            </Dialog>
            <DefaultModel
                modelNameOpen={modelNameOpen}
                setModelNameOpen={setModelNameOpen}
                handleModelNameClose={handleModelNameClose}
                modelName={modelName}
                handleModelName={handleModelName}
                project={projectId}
            />
            <TestURL
                openCurl={openCurl}
                handleCurlClose={handleCurlClose}
                project={projectId}
            />
            <Dialog open={openClone} onClose={handleCloneClose} aria-labelledby="clone-project" maxWidth="sm" fullWidth>
                <DialogTitle id="clone-project" style={{ position: 'relative', paddingRight: 48 }}>
                    {menuMode === "clone" ? "Clone project" : "Update project configuration"}
                    <IconButton onClick={handleCloneClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl variant="outlined" style={{ marginTop: 14 }}>
                        {menuMode === "clone" ? <>
                            <TextField
                                required
                                autoFocus
                                margin="normal"
                                id="name"
                                label="Project Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={handleName}
                                value={newName}
                            />
                            <TextField
                                select
                                value={version}
                                onChange={handleVersion}
                                label="Version"
                                variant="outlined"
                                style={{ width: 250 }}
                            >
                                {!modelVersion.includes("lex") ? <MenuItem value="1">1</MenuItem> : <></>}
                                {!modelVersion.includes("lex") ? <MenuItem value="3">3</MenuItem> : <></>}
                                {modelVersion.includes("lex") ? <MenuItem value="lex">lex</MenuItem> : <></>}
                            </TextField>
                        </> : <></>}
                        {version === "lex" ? <TextField
                            value={newLexModel}
                            onChange={handleNewLexModel}
                            label="Lex Model Name"
                            variant="outlined"
                            style={{ width: 250, marginTop: 14 }}
                        /> : <></>}
                        {version === "lex" ? <TextField
                            value={newLexMultiplier}
                            onChange={handleNewLexMultiplier}
                            label="Lex Multiplier"
                            variant="outlined"
                            style={{ width: 250, marginTop: 14 }}
                        /> : <></>}
                        {version === "lex" ? <TextField
                            select
                            value={newOCRType}
                            onChange={handleOcrType}
                            label="OCR type"
                            variant="outlined"
                            style={{ width: 250, marginTop: 14 }}
                        >
                            {Object.keys(ocrTypes).map((ocrType) => (
                                <MenuItem value={ocrType}>{ocrTypes[ocrType]}</MenuItem>
                            ))}
                        </TextField> : <></>}
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleCloneClose}>Cancel</HVButton>
                    {version === "lex"
                        ? <HVButton variant="primary" onClick={handleOpenNext}>Next</HVButton>
                        : <HVButton variant="primary" onClick={menuMode === 'clone' ? handleClone : handleUpdate}>{menuMode === 'clone' ? 'Clone' : 'Update'}</HVButton>
                    }
                </DialogActions>
            </Dialog>

            <Dialog open={openLexNext} onClose={handleCloneClose} aria-labelledby="configure-prompt" maxWidth="xl">
                <DialogTitle id="configure-prompt" style={{ position: 'relative', paddingRight: 48 }}>
                    Configure Prompt
                    <IconButton onClick={handleCloneClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Container>
                        <TextField
                            select
                            value={promptSelect}
                            onChange={handlePromptSelect}
                            label="Prompt Select"
                            variant="outlined"
                            style={{ width: 250 }}
                        >
                            <MenuItem value="prompt1">Standard Prompt 1</MenuItem>
                            <MenuItem value="prompt2">Standard Prompt 2</MenuItem>
                            <MenuItem value="custom">Custom Prompt</MenuItem>
                        </TextField>
                        <form>
                            {inputFields.map((lexInputField) => (
                                <div key={lexInputField.id} style={{ marginBottom: 10 }}>
                                    <FormControl style={{ marginTop: 15 }}>
                                        <TextField
                                            name="field"
                                            label="Field Name*"
                                            variant="outlined"
                                            value={lexInputField.field}
                                            onChange={(event) =>
                                                handleChangeLexInput(lexInputField.id, event)
                                            }
                                        />
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <FormControl style={{ marginLeft: 30, marginTop: 15 }}>
                                        <TextField
                                            name="description"
                                            label="Field Desciption"
                                            variant="outlined"
                                            value={lexInputField.description}
                                            onChange={(event) =>
                                                handleChangeLexInput(lexInputField.id, event)
                                            }
                                        />
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <FormControl style={{ marginLeft: 30, marginTop: 15 }}>
                                        <div>
                                            <Checkbox
                                                name="hallucinationCheck"
                                                label="hallucinationCheck"
                                                variant="outlined"
                                                value={lexInputField.hallucinationCheck}
                                                checked={lexInputField.hallucinationCheck}
                                                onChange={(event) =>
                                                    handleHallucinationCheck(lexInputField.id, event)
                                                }
                                            />
                                            <span>Hallucination Check</span>
                                        </div>
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <IconButton
                                        disabled={inputFields.length === 1}
                                        onClick={() => handleRemoveFields(lexInputField.id)}
                                    >
                                        <Remove />
                                    </IconButton>
                                    <IconButton onClick={handleAddFields}>
                                        <Add />
                                    </IconButton>
                                </div>
                            ))}
                        </form>
                        <br></br>
                        {promptSelect === "custom" ? (<FormControl fullWidth style={{ marginTop: 15 }}>
                            <TextField
                                name="customPrompt"
                                label="Custom Prompt"
                                variant="outlined"
                                value={promptForClone}
                                multiline
                                onChange={(event) =>
                                    handleChangeLexPrompt(event)
                                }
                            />
                        </FormControl>) : (<code>{promptForClone}</code>)}
                    </Container>
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleCloneClose}>Cancel</HVButton>
                    <HVButton variant="ghost" onClick={handleBack}>Back</HVButton>
                    {menuMode === "clone"
                        ? <HVButton variant="primary" onClick={handleClone}>Clone</HVButton>
                        : <HVButton variant="primary" onClick={handleUpdate}>Update</HVButton>
                    }
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDeleteTag}
                onClose={() => setOpenDeleteTag(false)}
                aria-labelledby="delete-tag"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogTitle id="delete-tag" style={{ position: 'relative', paddingRight: 48 }}>
                    Confirm deletion
                    <IconButton onClick={() => setOpenDeleteTag(false)} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to delete the tag <strong>{tagToDelete}</strong> from <strong>{name}</strong>?
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={() => setOpenDeleteTag(false)}>Cancel</HVButton>
                    <HVButton variant="danger" onClick={() => {
                        setOpenDeleteTag(false);
                        axios.post('/api/projects/removeTagFromProject', { projectId, tag: tagToDelete })
                            .then(res => { enqueueSnackbar(res.data, { variant: 'success' }); getStatus(); })
                            .catch(err => enqueueSnackbar(err.response.data, { variant: 'error' }));
                    }}>Remove tag</HVButton>
                </DialogActions>
            </Dialog>

            {/* Add tag dialog */}
            <Dialog open={openTagDialog} onClose={() => { setOpenTagDialog(false); setCustomTag(''); }} maxWidth="xs" fullWidth>
                <DialogTitle style={{ position: 'relative', paddingRight: 48 }}>
                    Add tag to project
                    <IconButton onClick={() => { setOpenTagDialog(false); setCustomTag(''); }} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: HV_THEME.mute, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 10 }}>Quick tags</div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {['Production', 'Testing', 'In Review'].map(preset => {
                                const already = tags && tags.includes(preset);
                                const tp = TAG_PALETTE[preset];
                                return (
                                    <button key={preset} onClick={() => handleAddTag(preset)} disabled={already} style={{
                                        background: already ? tp.bg : '#fff',
                                        color: already ? tp.fg : HV_THEME.ink,
                                        border: `1px solid ${already ? tp.bd : '#e0e0e0'}`,
                                        borderRadius: 99, padding: '7px 16px', fontSize: 12, fontWeight: 600,
                                        cursor: already ? 'default' : 'pointer', fontFamily: 'inherit',
                                        opacity: already ? 0.7 : 1
                                    }}>{preset}{already ? ' ✓' : ''}</button>
                                );
                            })}
                        </div>
                    </div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: HV_THEME.mute, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 8 }}>Custom tag</div>
                    <HVInput
                        placeholder="Enter tag name…"
                        value={customTag}
                        onChange={e => setCustomTag(e.target.value)}
                        onKeyPress={e => { if (e.key === 'Enter' && customTag.trim()) handleAddTag(customTag.trim()); }}
                    />
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
                    <HVButton variant="ghost" onClick={() => { setOpenTagDialog(false); setCustomTag(''); }}>Cancel</HVButton>
                    <HVButton variant="primary" disabled={!customTag.trim()} onClick={() => handleAddTag(customTag.trim())}>Add tag</HVButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

Project.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {})(Project);
